import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export function formatPrice(price, currency = 'EUR') {
  if (price == null || isNaN(price)) return '–';
  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(price);
}

export function formatDate(dateStr) {
  if (!dateStr) return '–';
  const d = new Date(dateStr);
  return d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

export function timeAgo(dateStr) {
  if (!dateStr) return 'Nie';
  const d = new Date(dateStr);
  const now = new Date();
  const diffMs = now - d;
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  if (diffHours < 1) return 'Gerade eben';
  if (diffHours < 24) return `Vor ${diffHours} Std.`;
  if (diffDays < 7) return `Vor ${diffDays} Tag${diffDays > 1 ? 'en' : ''}`;
  if (diffDays < 30) return `Vor ${Math.floor(diffDays / 7)} Woche${Math.floor(diffDays / 7) > 1 ? 'n' : ''}`;
  return formatDate(dateStr);
}

export function getFreshnessLevel(dateStr) {
  if (!dateStr) return 'stale';
  const d = new Date(dateStr);
  const now = new Date();
  const diffHours = (now - d) / (1000 * 60 * 60);
  if (diffHours < 24) return 'good';
  if (diffHours < 168) return 'warn'; // 7 days
  return 'stale';
}

export const PRICE_TYPE_LABELS = {
  registration: 'Registrierung',
  renewal: 'Verlängerung',
  transfer: 'Transfer',
};

export const CATEGORY_LABELS = {
  generic: 'Generisch',
  country: 'Länder',
  new: 'Neue TLDs',
};

export const PROMO_TYPE_LABELS = {
  fixed_price: 'Festpreis',
  percentage_off: 'Prozent-Rabatt',
  amount_off: 'Betrag-Rabatt',
};

export const PROMO_SCOPE_LABELS = {
  first_year: 'Nur 1. Jahr',
  all_years: 'Alle Jahre',
  one_time: 'Einmalig',
};

export const DATA_SOURCE_LABELS = {
  manual: 'Manuell',
  self_reported: 'Anbieter-Daten',
  import: 'Importiert',
  scraped: 'Automatisch erfasst',
  api: 'Anbieter-API',
};
